// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RdRD","comment":"styles_comment__o6DPv"};